import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';

import styles from '../../theme/staticpages.module.scss';
import '../../theme/global.scss';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';

const DataProcessingAgreement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={styles.containerStaticPage}>
      <div className={styles.steps}>
        <p className='bold'>
          ACORD PRIVIND PRELUCRAREA A DATELOR PERSONALE ALE UTILIZATORILOR
          SOFTWARE-ULUI SIRAR
        </p>
        <Space vertical={variables.verticalSpace} />

        <p>
          <b>Versiunea [1]</b>
          <br></br>
          <b>Data ultime actualizari: [27.10.2021]</b>
        </p>
        <Space vertical={variables.verticalSpace} />

        <ol type='I'>
          <li>
            <p>
              <b>Părțile</b>
            </p>
            <ol type='1'>
              <li>
                <p>
                  Dvs., utilizatorul software-ului SIRAR (“<b>Software</b>”),
                  actionand in calitate de operator de date cu caracter personal
                  (denumit in continuare „<b>Dvs.</b>” sau “<b>Utilizatorul</b>”
                  sau “<b>Operatorul</b>”) și
                </p>
              </li>
              <li>
                <p>
                  <b>SIRAR SOLUTIONS S.R.L.</b>, societate de drept roman cu
                  sediul in municipiul Târgovişte, str. G-ral Matei Vlădescu,
                  nr. 1, bloc 18, etaj 2, apartament 12, județ Dâmboviţa,
                  inregistrata la registrul comertului cu nr. J15/346/2021, CUI:
                  43852251, proprietar exclusiv al Software-ului Sirar,
                  acționând in calitate de persoana imputernicita sa prelucreze
                  date cu caracter personal (denumită “<b>SIRAR</b>” sau “
                  <b>noi</b>”); și denumite, în mod individual, ”<b>Partea</b>”
                  și în mod colectiv ”<b>Părțile</b>”.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <b>Preambul</b>
            </p>
            <ol type='1'>
              <li>
                <p>
                  În decursul utilizării Software-ului, Dvs. puteți introduce,
                  stoca sau face accesibile în prin intermediul Software-ului
                  diverse date cu caracter personal (”<b>Date personale</b>”)
                  ale unor persoane vizate („<b>Persoanele vizate</b>”), așa cum
                  sunt aceste concepte definite în legislația aplicabilă, în
                  special, dar fără a se limita la prevederile REGULAMENTULULUI
                  (UE) 2016/679 AL PARLAMENTULUI EUROPEAN și AL CONSILIULUI (”
                  <b>GDPR</b>”);
                </p>
              </li>
              <li>
                <p>
                  SIRAR prelucrează Datele personale introduse prin intermediul
                  Software-ului:{' '}
                </p>
                <ol type='a'>
                  <li>
                    <p>
                      în calitate de operator de date cu caracter personal –
                      respectiv, datele de contract ale reprezentanților
                      Utilizatorilor („
                      <b>Date personale prelucrate ca operator</b>” ), potrivit
                      distincțiilor din{' '}
                      <a href='https://dev.sirar.ro/politica-de-confidentialitate'>
                        Politica de confidențialitate a Software-ului
                      </a>
                      ,
                    </p>
                    și{' '}
                  </li>
                  <li>
                    <p>
                      în calitate de persoana împuternicită să prelucreze date
                      cu caracter personal – respectiv, datele introduse sau
                      generate de Utilizatori (“
                      <b>Date personale prelucrate ca împuternicit</b>”) pentru
                      a beneficia de funcționalitățile Software-ului, respectiv
                      monitorizarea de catre instituțiile publice inrolate in
                      platforma Sirar a implementarii masurilor dispuse sau
                      recomandate de catre organele de audit si/sau control
                      competente, in urma inspectiilor efectuate la asemenea
                      institutii publice, precum si monitorizarea stadiului
                      dosarelor de instanta prin interogarea portalului{' '}
                      <a href='www.just.ro'>www.just.ro</a>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  In ceea ce privește Datele personale prelucrate ca
                  împuternicit, este necesar, potrivit art. 28 din GDPR, să fie
                  reglementată relația dintre SIRAR, în calitate de persoană
                  împuternicită să prelucreze Date personale, și Utilizator, în
                  calitate de operator de Date personale.
                </p>
              </li>
              <li>
                <p>
                  Luând în considerare dispozițiile Deciziei de punere în
                  aplicare (UE) 2021/915 a Comisiei din 4 iunie 2021privind
                  clauzele contractuale standard dintre operatori și persoanele
                  împuternicite de operatori prevăzute la articolul 28 alineatul
                  (7) din Regulamentul (UE) 2016/679 al Parlamentului European
                  și al Consiliului și la articolul 29 alineatul (7) din
                  Regulamentul (UE) 2018/1725 al Parlamentului European și al
                  Consiliului (“<b>Decizia 2021/915</b>”) Partile au incheiat
                  prezentul acord de prelucrare a datelor cu caracter personal
                  („<b>Acordul</b>”).
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <ol type='I'>
          <li value='3'>
            <p>
              <b>Structura Acordului</b>
            </p>
          </li>
          <ol type='1'>
            <li>
              <p>
                <b>Partea I</b> care cuprinde:
              </p>
              <ol type='a'>
                <li>
                  <p>
                    Clauzele contractuale standard prevăzute de Decizia
                    2021/915, precum si{' '}
                  </p>
                </li>
                <li>
                  <p>Anexa I – Lista Părților;</p>
                </li>
                <li>
                  <p>Anexa II – Descrierea prelucrării;</p>
                </li>
                <li>
                  <p>
                    Anexa III – Măsuri tehnice și organizatorice, inclusiv
                    măsuri tehnice și organizatorice menite să asigure
                    securitatea datelor;
                  </p>
                </li>
                <li>
                  <p>Anexa IV – Lista subcontractanților (subîmputerniciții)</p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                <b>Partea II</b> - Clauze suplimentare
              </p>
            </li>
          </ol>
        </ol>
        <h5>
          <p>
            <b>Partea I - Clauze contractuale-standard</b>
          </p>
        </h5>
        <h4>
          <p>
            <b>SECȚIUNEA I</b>
          </p>
        </h4>
        <ol type='1'>
          <li>
            <p>
              <b>Clauza 1</b>
            </p>
            <p>
              <b>
                <i>Scopul și domeniul de aplicare</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  Scopul prezentelor clauze contractuale standard („
                  <b>clauzele</b>”) este de a asigura conformitatea cu articolul
                  28 alineatele (3) și (4) din Regulamentul (UE) 2016/679 al
                  Parlamentului European și al Consiliului din 27 aprilie 2016
                  privind protecția persoanelor fizice în ceea ce privește
                  prelucrarea datelor cu caracter personal și privind libera
                  circulație a acestor date și de abrogare a Directivei 95/46/CE
                  (Regulamentul general privind protecția datelor).
                </p>
              </li>
              <li>
                <p>
                  Operatorii și persoanele împuternicite de operatori enumerate
                  în Anexa I au convenit asupra prezentelor clauze pentru a
                  asigura conformitatea cu articolul 28 alineatele (3) și (4)
                  din Regulamentul (UE) 2016/679 și cu articolul 29 alineatele
                  (3) și (4) din Regulamentul (UE) 2018/1725.
                </p>
              </li>
              <li>
                <p>
                  Prezentele clauze se aplică prelucrării datelor cu caracter
                  personal, astfel cum se specifică în anexa II.
                </p>
              </li>
              <li>
                <p>Anexele I-IV fac parte integrantă din clauze.</p>
              </li>
              <li>
                <p>
                  Prezentele clauze nu aduc atingere obligațiilor care îi revin
                  operatorului în temeiul Regulamentului (UE) 2016/679 și/sau al
                  Regulamentului (UE) 2018/1725.
                </p>
              </li>
              <li>
                <p>
                  Prezentele clauze nu asigură, prin ele însele, respectarea
                  obligațiilor referitoare la transferurile internaționale în
                  conformitate cu capitolul V din Regulamentul (UE) 2016/679
                  și/sau din Regulamentul (UE) 2018/1725.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <b>Clauza 2</b>
            </p>
            <p>
              <b>
                <i>Caracterul invariabil al clauzelor</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  Părțile se angajează să nu modifice clauzele, cu excepția
                  cazului în care trebuie să completeze sau să actualizeze
                  informațiile prevăzute în anexe.
                </p>
              </li>
              <li>
                <p>
                  Acest lucru nu împiedică părțile să includă clauzele
                  contractuale standard prevăzute în prezentele clauze în cadrul
                  unui contract mai amplu sau să adauge alte clauze sau garanții
                  suplimentare, atât timp cât acestea nu contravin, direct sau
                  indirect, clauzelor sau nu aduc atingere drepturilor sau
                  libertăților fundamentale ale persoanelor vizate.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <b>Clauza 3</b>
            </p>
            <p>
              <b>
                <i>Interpretare</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  În cazul în care prezentele clauze utilizează termenii
                  definiți în Regulamentul (UE) 2016/679 sau în Regulamentul
                  (UE) 2018/1725, acești termeni au același sens ca în
                  regulament.
                </p>
              </li>
              <li>
                <p>
                  Prezentele clauze trebuie citite și interpretate în lumina
                  dispozițiilor Regulamentului (UE) 2016/679 sau ale
                  Regulamentului (UE) 2018/1725.
                </p>
              </li>
              <li>
                <p>
                  Prezentele clauze nu trebuie interpretate într-un mod care
                  contravine drepturilor și obligațiilor prevăzute în
                  Regulamentul (UE) 2016/679/Regulamentul (UE) 2018/1725 sau
                  într-un mod care aduce atingere drepturilor sau libertăților
                  fundamentale ale persoanelor vizate.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <b>Clauza 4</b>
            </p>
            <p>
              <b>
                <i>Ierarhie</i>
              </b>
            </p>
            <p>
              În cazul unei contradicții între prezentele clauze și dispozițiile
              acordurilor conexe dintre părți care există la momentul în care
              sunt convenite prezentele clauze sau care sunt încheiate ulterior,
              prevalează prezentele clauze.
            </p>
          </li>
          <li>
            <p>
              <b>Clauza 5</b>
            </p>
            <p>
              <b>
                <i>Clauză privind aderarea unor părți noi</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  O entitate care nu este parte la prezentele clauze poate
                  adera, cu acordul tuturor părților, la prezentele clauze în
                  orice moment în calitate de operator sau de persoană
                  împuternicită de operator prin completarea anexelor și prin
                  semnarea Anexei I.
                </p>
              </li>
              <li>
                <p>
                  După completarea și semnarea anexelor menționate la litera
                  (a), entitatea care a aderat este considerată drept parte la
                  prezentele clauze și are drepturile și obligațiile unui
                  operator sau ale unei persoane împuternicite de operator, în
                  conformitate cu desemnarea sa prevăzută în Anexa I.
                </p>
              </li>
              <li>
                <p>
                  Entitatea care a aderat nu are drepturi sau obligații ce
                  decurg din prezentele clauze pentru perioada anterioară
                  dobândirii calității de parte.{' '}
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <h4>
          <p>
            <b>SECȚIUNEA II</b>
          </p>
        </h4>
        <h4>
          <p>
            <b>OBLIGAȚIILE PĂRȚILOR</b>
          </p>
        </h4>
        <ol type='1'>
          <li value='6'>
            <p>
              <b>Clauza 6</b>
            </p>
            <p>
              <b>
                <i>Descrierea prelucrării (prelucrărilor) datelor</i>
              </b>
            </p>
            <p>
              Operațiunile de prelucrare, în special categoriile de date cu
              caracter personal și scopurile prelucrării datelor cu caracter
              personal în numele operatorului, sunt specificate în detaliu în
              Anexa II.
            </p>
          </li>
          <li>
            <p>
              <b>Clauza 7</b>
            </p>
            <p>
              <b>
                <i>Obligațiile părților</i>
              </b>
            </p>
            <ul className={styles.ulNone}>
              <li>
                <p>7.1. Instrucțiuni</p>
                <ol type='a'>
                  <li>
                    <p>
                      Persoana împuternicită de operator prelucrează datele cu
                      caracter personal numai pe baza unor instrucțiuni
                      documentate din partea operatorului, cu excepția cazului
                      în care persoanei împuternicite de operator îi revine
                      această obligație în temeiul dreptului Uniunii sau al
                      dreptului intern care i se aplică. În acest caz, persoana
                      împuternicită de operator îl informează pe operator cu
                      privire la respectiva obligație juridică înainte de
                      prelucrare, cu excepția situației în care legislația
                      interzice o astfel de informare din motive importante
                      legate de interesul public. De asemenea, operatorul poate
                      da instrucțiuni ulterioare pe întreaga durată a
                      prelucrării datelor cu caracter personal. Aceste
                      instrucțiuni trebuie să fie întotdeauna documentate.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator îl informează imediat
                      pe operator în cazul în care, în opinia sa, instrucțiunile
                      date de operator încalcă Regulamentul (UE)
                      2016/679/Regulamentul (UE) 2018/1725 sau dispozițiile
                      aplicabile ale dreptului Uniunii sau ale dreptului intern
                      referitoare la protecția datelor.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>7.2. Limitarea scopului</p>
                <p>
                  Persoana împuternicită de operator prelucrează datele cu
                  caracter personal numai în scopul (scopurile) specific(e)
                  al(e) prelucrării, astfel cum se prevede în anexa II, cu
                  excepția cazului în care primește instrucțiuni suplimentare
                  din partea operatorului.
                </p>
              </li>
              <li>
                <p>7.3. Durata prelucrării datelor cu caracter personal</p>
                <p>
                  Prelucrarea de către persoana împuternicită de operator are
                  loc numai pe durata specificată în anexa II.
                </p>
              </li>
              <li>
                <p>7.4. Securitatea prelucrării</p>
                <ol type='a'>
                  <li>
                    <p>
                      Persoana împuternicită de operator implementează cel puțin
                      măsurile tehnice și organizatorice specificate în anexa
                      III pentru a asigura securitatea datelor cu caracter
                      personal. Printre aceste măsuri se numără protecția
                      datelor împotriva unei încălcări a securității care duce,
                      în mod accidental sau ilegal, la distrugerea, pierderea,
                      modificarea, divulgarea neautorizată a datelor cu caracter
                      personal sau la accesul neautorizat la acestea (încălcarea
                      securității datelor cu caracter personal). La evaluarea
                      nivelului adecvat de securitate, părțile iau în
                      considerare în mod corespunzător stadiul actual al
                      tehnologiei, costurile implementării, natura, domeniul de
                      aplicare, contextul și scopurile prelucrării, precum și
                      riscurile la care sunt expuse persoanele vizate.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator acordă membrilor
                      personalului său acces la datele cu caracter personal care
                      fac obiectul prelucrării numai în măsura în care acest
                      lucru este strict necesar pentru executarea, gestionarea
                      și monitorizarea contractului. Persoana împuternicită de
                      operator se asigură că persoanele autorizate să prelucreze
                      datele cu caracter personal primite s-au angajat să
                      respecte confidențialitatea sau au o obligație statutară
                      adecvată de confidențialitate.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>7.5. Date sensibile</p>
                <p>
                  Dacă prelucrarea implică date cu caracter personal care
                  dezvăluie originea rasială sau etnică, opiniile politice,
                  confesiunea religioasă sau convingerile filozofice sau
                  apartenența la sindicate, date genetice sau date biometrice
                  pentru identificarea unică a unei persoane fizice, date
                  privind sănătatea sau date privind viața sexuală sau
                  orientarea sexuală a unei persoane fizice sau date referitoare
                  la condamnări penale și infracțiuni („<b>date sensibile</b>”),
                  persoana împuternicită de operator aplică restricții specifice
                  și/sau garanții suplimentare.
                </p>
              </li>
              <li>
                <p>7.6. Documentație și conformitate</p>
                <ol type='a'>
                  <li>
                    <p>
                      Părțile trebuie să fie în măsură să demonstreze
                      respectarea prezentelor clauze.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator răspunde cu
                      promptitudine și în mod adecvat cererilor de informații
                      din partea operatorului cu privire la prelucrarea datelor
                      în conformitate cu prezentele clauze.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator pune la dispoziția
                      operatorului toate informațiile necesare pentru a
                      demonstra respectarea obligațiilor prevăzute în prezentele
                      clauze și care rezultă în mod direct din Regulamentul (UE)
                      2016/679 și/sau din Regulamentul (UE) 2018/1725. De
                      asemenea, la cererea operatorului, persoana împuternicită
                      de operator trebuie să permită efectuarea de audituri ale
                      activităților de prelucrare care fac obiectul prezentelor
                      clauze și să contribuie la aceste audituri, la intervale
                      rezonabile sau dacă există indicii privind nerespectarea
                      prezentelor clauze. În luarea unei decizii privind
                      efectuarea unei analize sau a unui audit, operatorul poate
                      ține seama de certificările relevante deținute de persoana
                      împuternicită de operator.
                    </p>
                  </li>
                  <li>
                    <p>
                      Operatorul poate alege să efectueze el însuși auditul sau
                      să mandateze în acest scop un auditor independent.
                      Auditurile pot include, de asemenea, inspecții la sediile
                      sau la instalațiile fizice ale persoanei împuternicite de
                      operator și se efectuează, dacă este cazul, în urma
                      transmiterii unui preaviz rezonabil.
                    </p>
                  </li>
                  <li>
                    <p>
                      La cerere, părțile pun la dispoziția
                      autorității/autorităților de supraveghere competente
                      informațiile menționate în prezenta clauză, inclusiv
                      rezultatele oricărui audit.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>7.7. Recurgerea la subcontractanți</p>
                <ol type='a'>
                  <li>
                    <p>
                      <b>AUTORIZAȚIE SCRISĂ GENERALĂ</b>: Persoana împuternicită
                      de operator deține autorizația generală din partea
                      operatorului de a recruta subcontractanți care figurează
                      pe o listă convenită. Persoana împuternicită de operator
                      îl informează în mod specific în scris pe operator cu
                      privire la orice modificări preconizate ale listei prin
                      adăugarea sau înlocuirea subcontractanților cu cel puțin
                      [10 zile lucratoare] înainte, oferindu-i astfel
                      operatorului suficient timp pentru a putea formula
                      obiecții referitoare la aceste modificări înainte de
                      recrutarea subcontractantului (subcontractanților) în
                      cauză. Persoana împuternicită de operator îi furnizează
                      operatorului informațiile de care acesta are nevoie pentru
                      exercitarea dreptului de a formula obiecții.
                    </p>
                  </li>
                  <li>
                    <p>
                      În cazul în care persoana împuternicită de operator
                      recrutează un subcontractant pentru a desfășura activități
                      de prelucrare specifice (în numele operatorului), trebuie
                      să efectueze recrutarea printr-un contract care să
                      prevadă, pe fond, aceleași obligații în materie de
                      protecție a datelor ca cele care îi revin persoanei
                      împuternicite de operator în conformitate cu prezentele
                      clauze. Persoana împuternicită de operator se asigură că
                      subcontractantul respectă obligațiile care îi revin
                      persoanei împuternicite de operator în temeiul prezentelor
                      clauze și al Regulamentului (UE) 2016/679 și/sau al
                      Regulamentului (UE) 2018/1725.
                    </p>
                  </li>
                  <li>
                    <p>
                      La cererea operatorului, persoana împuternicită de
                      operator îi furnizează operatorului o copie a acestui
                      contract de subcontractare și a oricăror modificări
                      ulterioare. În măsura în care acest lucru este necesar
                      pentru a proteja secretul de afaceri sau alte informații
                      confidențiale, inclusiv date cu caracter personal,
                      persoana împuternicită de operator poate să mascheze
                      textul contractului înainte de a transmite copia.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator rămâne pe deplin
                      responsabilă față de operator pentru îndeplinirea
                      obligațiilor subcontractantului în conformitate cu
                      contractul său cu persoana împuternicită de operator.
                      Persoana împuternicită de operator notifică operatorului
                      orice nerespectare de către subcontractant a obligațiilor
                      sale contractuale.
                    </p>
                  </li>
                  <li>
                    <p>
                      Persoana împuternicită de operator convine cu
                      subcontractantul asupra unei clauze privind terțul
                      beneficiar, conform căreia – în cazul în care persoana
                      împuternicită de operator a dispărut în fapt, și-a încetat
                      existența de drept sau a devenit insolvabil – operatorul
                      are dreptul de a rezilia contractul cu subcontractantul și
                      de a-i da subcontractantului instrucțiuni să șteargă sau
                      să returneze datele cu caracter personal.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>7.8. Transferuri internaționale</p>
                <ol type='a'>
                  <li>
                    <p>
                      Orice transfer de date către o țară terță sau o
                      organizație internațională realizat de persoana
                      împuternicită de operator are loc pe baza instrucțiunilor
                      documentate din partea operatorului sau pentru a îndeplini
                      o cerință specifică în temeiul dreptului Uniunii sau al
                      dreptului intern care i se aplică persoanei împuternicite
                      de operator și se desfășoară în conformitate cu capitolul
                      V din Regulamentul (UE) 2016/679 sau din Regulamentul (UE)
                      2018/1725.
                    </p>
                  </li>
                  <li>
                    <p>
                      Operatorul este de acord că, în cazul în care persoana
                      împuternicită de operator recrutează un subcontractant în
                      conformitate cu clauza 7.7 pentru a desfășura activități
                      de prelucrare specifice (în numele operatorului) și
                      respectivele activități de prelucrare implică un transfer
                      de date cu caracter personal în sensul capitolului V din
                      Regulamentul (UE) 2016/679, persoana împuternicită de
                      operator și subcontractantul pot asigura respectarea
                      dispozițiilor prevăzute în capitolul V din Regulamentul
                      (UE) 2016/679 prin recurgerea la clauzele contractuale
                      standard adoptate de Comisie în conformitate cu articolul
                      46 alineatul (2) din Regulamentul (UE) 2016/679, cu
                      condiția îndeplinirii condițiilor privind recurgerea la
                      respectivele clauze contractuale standard.
                    </p>
                  </li>
                </ol>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <b>Clauza 8</b>
            </p>
            <p>
              <b>
                <i>Asistența acordată operatorului</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  Persoana împuternicită de operator notifică imediat
                  operatorului orice cerere primită din partea unei persoane
                  vizate. Persoana împuternicită de operator răspunde cererii
                  respective doar dacă a fost autorizată să facă acest lucru de
                  către operator.
                </p>
              </li>
              <li>
                <p>
                  Persoana împuternicită de operator trebuie să îi acorde
                  asistență operatorului în îndeplinirea obligațiilor acestuia
                  de a răspunde cererilor formulate de persoanele vizate pentru
                  a-și exercita drepturile, ținând seama de natura prelucrării.
                  În îndeplinirea obligațiilor care îi revin în conformitate cu
                  literele (a) și (b), persoana împuternicită de operator
                  respectă instrucțiunile operatorului.
                </p>
              </li>
              <li>
                <p>
                  În plus față obligația persoanei împuternicite de operator de
                  a-i acorda asistență operatorului în temeiul clauzei 8 litera
                  (b), persoana împuternicită de operator îi acordă asistență
                  acestuia și în ceea ce privește asigurarea respectării
                  următoarelor obligații, ținând seama de natura prelucrării
                  datelor și de informațiile aflate la dispoziția persoanei
                  împuternicite de operator:
                </p>
                <ol type='1'>
                  <li>
                    <p>
                      obligația de a efectua o evaluare a impactului
                      operațiunilor de prelucrare prevăzute asupra protecției
                      datelor cu caracter personal (o „evaluare a impactului
                      asupra protecției datelor”), în cazul în care un tip de
                      prelucrare este susceptibil să genereze un risc ridicat
                      pentru drepturile și libertățile persoanelor fizice;
                    </p>
                  </li>
                  <li>
                    <p>
                      obligația de a consulta autoritatea/autoritățile de
                      supraveghere competentă/competente înainte de prelucrare,
                      în cazul în care o evaluare a impactului asupra protecției
                      datelor indică faptul că prelucrarea ar genera un risc
                      ridicat în absența unor măsuri luate de operator pentru
                      atenuarea riscului;
                    </p>
                  </li>
                  <li>
                    <p>
                      obligația de a se asigura că datele cu caracter personal
                      sunt exacte și actualizate, prin înștiințarea operatorului
                      fără întârziere în cazul în care persoana împuternicită de
                      operator a luat cunoștință de faptul că datele cu caracter
                      personal prelucrate sunt inexacte sau nu mai sunt de
                      actualitate;
                    </p>
                  </li>
                  <li>
                    <p>
                      obligațiile prevăzute la [OPȚIUNEA 1] articolul 32 din
                      Regulamentul (UE) 2016/679/[OPȚIUNEA 2] articolul 33, la
                      articolele 36–38 din Regulamentul (UE) 2018/1725.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Părțile stabilesc în anexa III măsurile tehnice și
                  organizatorice adecvate prin intermediul cărora persoana
                  împuternicită de operator are obligația de a-i acorda
                  asistență operatorului în aplicarea prezentei clauze, precum
                  și domeniul de aplicare și amploarea asistenței necesare.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <b>Clauza 9</b>
            </p>
            <p>
              Notificarea încălcării securității datelor cu caracter personal
            </p>
            <p>
              În cazul în care are loc o încălcare a securității datelor cu
              caracter personal, persoana împuternicită de operator cooperează
              cu operatorul și îi acordă asistența necesară pentru ca acesta să
              își respecte obligațiile care îi revin în temeiul articolelor 33
              și 34 din Regulamentul (UE) 2016/679 sau în temeiul articolelor 34
              și 35 din Regulamentul (UE) 2018/1725, dacă este cazul, ținând
              seama de natura prelucrării și de informațiile aflate la
              dispoziția persoanei împuternicite de operator.
            </p>
            <ul className={styles.ulNone}>
              <li>
                <p>
                  9.1. Încălcarea securității datelor privind date prelucrate de
                  operator
                </p>
                <p>
                  În cazul în care are loc o încălcare a securității datelor cu
                  caracter personal privind date prelucrate de operator,
                  persoana împuternicită de operator îi acordă asistența
                  operatorului:
                </p>
                <ol type='a'>
                  <li>
                    <p>
                      în notificarea încălcării securității datelor cu caracter
                      personal către autoritatea/autoritățile de supraveghere
                      competentă/competente, fără întârzieri nejustificate, după
                      ce operatorul a luat cunoștință de aceasta, dacă este
                      cazul / (cu excepția cazului în care încălcarea
                      securității datelor cu caracter personal nu este
                      susceptibilă să genereze un risc pentru drepturile și
                      libertățile persoanelor fizice);
                    </p>
                  </li>
                  <li>
                    <p>
                      în obținerea următoarelor informații care, în temeiul
                      [OPȚIUNEA 1] articolului 33 alineatul (3) din Regulamentul
                      (UE) 2016/679/[OPȚIUNEA 2] articolului 34 alineatul (3)
                      din Regulamentul (UE) 2018/1725, trebuie să fie menționate
                      în notificarea adresată operatorului și să includă cel
                      puțin:
                    </p>
                    <ol type='1'>
                      <li>
                        <p>
                          natura datelor cu caracter personal, inclusiv, acolo
                          unde este posibil, categoriile și numărul aproximativ
                          de persoane vizate în cauză, precum și categoriile și
                          numărul aproximativ de înregistrări de date cu
                          caracter personal în cauză;
                        </p>
                      </li>
                      <li>
                        <p>
                          consecințele probabile ale încălcării securității
                          datelor cu caracter personal;
                        </p>
                      </li>
                      <li>
                        <p>
                          măsurile luate sau propuse spre a fi luate de operator
                          pentru a remedia încălcarea securității datelor cu
                          caracter personal, inclusiv, după caz, măsurile pentru
                          atenuarea eventualelor sale efecte negative.
                        </p>
                      </li>
                    </ol>
                    <p>
                      Atunci când și în măsura în care nu este posibil să se
                      furnizeze toate aceste informații în același timp,
                      notificarea inițială trebuie să conțină informațiile
                      disponibile la momentul respectiv, informațiile
                      suplimentare urmând să fie puse la dispoziție ulterior,
                      fără întârzieri nejustificate, pe măsură ce devin
                      disponibile.
                    </p>
                  </li>
                  <li>
                    <p>
                      în respectarea, în temeiul [OPȚIUNEA 1] articolului 34 din
                      Regulamentul (UE) 2016/679/[OPȚIUNEA 2] articolului 35 din
                      Regulamentul (UE) 2018/1725, a obligației de a informa,
                      fără întârzieri nejustificate, persoana vizată cu privire
                      la încălcarea securității datelor cu caracter personal,
                      atunci când încălcarea securității datelor cu caracter
                      personal este susceptibilă să genereze un risc ridicat
                      pentru drepturile și libertățile persoanelor fizice.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  9.2. Încălcarea securității datelor privind date prelucrate de
                  persoana împuternicită de operator
                </p>
                <p>
                  În cazul în care are loc o încălcare a securității datelor cu
                  caracter personal privind date prelucrate de persoana
                  împuternicită de operator, aceasta din urmă, după ce a luat
                  cunoștință de respectiva încălcare, transmite, fără întârzieri
                  nejustificate, o notificare operatorului. Această notificare
                  trebuie să conțină cel puțin:
                </p>
                <ol type='a'>
                  <li>
                    <p>
                      o descriere a caracterului încălcării securității datelor
                      (inclusiv, acolo unde este posibil, categoriile de
                      persoane vizate în cauză, precum și numărul aproximativ de
                      persoane vizate și de înregistrări de date în cauză);
                    </p>
                  </li>
                  <li>
                    <p>
                      coordonatele unui punct de contact de unde se pot obține
                      mai multe informații privind încălcarea securității
                      datelor cu caracter personal;
                    </p>
                  </li>
                  <li>
                    <p>
                      consecințele probabile ale încălcării securității datelor
                      și măsurile luate sau propuse spre a fi luate pentru a
                      remedia încălcarea securității datelor, inclusiv pentru
                      atenuarea eventualelor sale efecte negative.
                    </p>
                  </li>
                </ol>
                <p>
                  Atunci când și în măsura în care nu este posibil să se
                  furnizeze toate aceste informații în același timp, notificarea
                  inițială trebuie să conțină informațiile disponibile la
                  momentul respectiv, informațiile suplimentare urmând să fie
                  puse la dispoziție ulterior, fără întârzieri nejustificate, pe
                  măsură ce devin disponibile.
                </p>
                <p>
                  Părțile stabilesc în anexa III toate celelalte elemente pe
                  care trebuie să le furnizeze persoana împuternicită de
                  operator atunci când îi acordă asistență operatorului pentru
                  ca acesta să își respecte obligațiile care îi revin în temeiul
                  [OPȚIUNEA 1] articolelor 33 și 34 din Regulamentul (UE)
                  2016/679/[OPȚIUNEA 2] articolelor 34 și 35 din Regulamentul
                  (UE) 2018/1725.
                </p>
              </li>
            </ul>
          </li>
        </ol>
        <h4>
          <p>
            <b>SECȚIUNEA III</b>
          </p>
        </h4>
        <h4>
          <p>
            <b>DISPOZIȚII FINALE</b>
          </p>
        </h4>
        <ol type='1'>
          <li value='10'>
            <p>
              <b>Clauza 10</b>
            </p>
            <p>
              <b>
                <i>Nerespectarea clauzelor și rezilierea</i>
              </b>
            </p>
            <ol type='a'>
              <li>
                <p>
                  Fără a aduce atingere dispozițiilor Regulamentului (UE)
                  2016/679 și/sau ale Regulamentului (UE) 2018/1725, în cazul în
                  care persoana împuternicită de operator nu respectă
                  obligațiile care îi revin în temeiul prezentelor clauze,
                  operatorul poate da instrucțiuni persoanei împuternicite de
                  operator să suspende prelucrarea datelor cu caracter personal
                  până când aceasta din urmă se conformează prezentelor clauze
                  sau până când se reziliază contractul. Persoana împuternicită
                  de operator îl informează cu promptitudine pe operator în
                  cazul în care nu este în măsură să respecte prezentele clauze,
                  indiferent de motiv.
                </p>
              </li>
              <li>
                <p>
                  Operatorul are dreptul de a rezilia contractul în măsura în
                  care acesta are ca obiect prelucrarea datelor cu caracter
                  personal în conformitate cu prezentele clauze, dacă:
                </p>
                <ol type='1'>
                  <li>
                    <p>
                      prelucrarea datelor cu caracter personal de către persoana
                      împuternicită de operator a fost suspendată de operator în
                      temeiul literei (a) și dacă respectarea prezentelor clauze
                      nu este restabilită într-un termen rezonabil și, în orice
                      caz, în termen de o lună de la suspendare;
                    </p>
                  </li>
                  <li>
                    <p>
                      persoana împuternicită de operator a încălcat în mod
                      substanțial sau repetat prezentele clauze sau obligațiile
                      care îi revin în temeiul Regulamentului (UE) 2016/679
                      și/sau al Regulamentului (UE) 2018/1725;
                    </p>
                  </li>
                  <li>
                    <p>
                      persoana împuternicită de operator nu respectă o decizie
                      cu caracter obligatoriu pronunțată de o instanță
                      competentă sau emisă de autoritatea/de autoritățile de
                      supraveghere competentă/competente în legătură cu
                      obligațiile care îi revin în temeiul prezentelor clauze
                      sau în temeiul Regulamentului (UE) 2016/679 și/sau al
                      Regulamentului (UE) 2018/1725.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Persoana împuternicită de operator are dreptul de a rezilia
                  contractul în măsura în care acesta are ca obiect prelucrarea
                  datelor cu caracter personal în temeiul prezentelor clauze, în
                  cazul în care, după ce l-a informat pe operator că
                  instrucțiunile sale încalcă obligațiile juridice aplicabile în
                  conformitate cu clauza 7.1 litera (b), operatorul insistă
                  asupra respectării instrucțiunilor.
                </p>
              </li>
              <li>
                <p>
                  În urma rezilierii contractului, la alegerea operatorului,
                  persoana împuternicită de operator șterge toate datele cu
                  caracter personal prelucrate în numele operatorului și îi
                  prezintă operatorului dovada faptului că a întreprins această
                  acțiune sau îi returnează operatorului toate datele cu
                  caracter personal și șterge copiile existente, cu excepția
                  cazului în care dreptul Uniunii sau dreptul intern prevede
                  obligația stocării datelor cu caracter personal. Până la
                  ștergerea sau returnarea datelor, operatorul trebuie să
                  continue să asigure respectarea acestor clauze.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <Space vertical={variables.verticalSpace} />
        <h4>
          <p>
            <b>ANEXA I</b>
          </p>
        </h4>
        <p>
          <b>Lista părților</b>
        </p>
        <p>
          <b>Operator (operatori)</b>
        </p>
        <p>Utilizatorii Software-ului SIRAR </p>
        <p>
          <b>Persoană (persoane) împuternicită (împuternicite) de operator:</b>
        </p>
        <p>
          SIRAR SOLUTIONS S.R.L., societate de drept roman cu sediul in
          municipiul Târgovişte, str. G-ral Matei Vlădescu, nr. 1, bloc 18, etaj
          2, apartament 12, județ Dâmboviţa, inregistrata la registrul
          comertului cu nr. J15/346/2021, CUI: 43852251, e-mail: [...]
        </p>
        <Space vertical={variables.verticalSpace} />
        <h4>
          <p>
            <b>ANEXA II</b>
          </p>
        </h4>
        <p>
          <b>
            <i>Descrierea prelucrării</i>
          </b>
        </p>
        <p>
          <b>
            <i>
              Categoriile de persoane vizate ale căror date cu caracter personal
              sunt prelucrate
            </i>
          </b>
        </p>
        <ul className={styles.ulNone}>
          <li>
            <p>
              Persoanele vizate ale caror date sunt introduse, stocate sau
              facute accesibile in cadrul sau prin Software de catre
              Utilizatori.
            </p>
          </li>
        </ul>
        <p>
          <b>
            <i>Categoriile de date cu caracter personal prelucrate</i>
          </b>
        </p>
        <ul className={styles.ulNone}>
          <li>
            <p>Nume, prenume, adresa de e-mail, alte date de identificare.</p>
          </li>
          <li>
            <p>
              La datele de mai sus se adauga si o serie de informatii si date,
              inclusiv date personale, care va permit utilizarea Software-ului
              sau care au legatura cu aceasta (cum ar fi informatiile cuprinse
              in rapoartele de audit sau rapoartele de control ale Curtii de
              Conturi).
            </p>
          </li>
        </ul>
        <p>
          <i>
            <b>Datele sensibile prelucrate</b> (dacă este cazul) și restricțiile
            sau garanțiile aplicate care țin seama pe deplin de caracterul
            datelor și de riscurile implicate, cum ar fi, de exemplu, limitarea
            strictă a scopului, restricții legate de acces (inclusiv permiterea
            accesului doar pentru membrii personalului care au urmat o formare
            specializată), ținerea unei evidențe a accesului la date, restricții
            aplicabile transferurilor ulterioare sau măsuri de securitate
            suplimentare.
          </i>
        </p>
        <p>
          <b>
            <i>(Nu este cazul de date sensibile)</i>
          </b>
        </p>
        <p>
          <b>
            <i>Natura prelucrării</i>
          </b>
        </p>
        <p>
          Prelucrările privesc Datele personale pe care Utilizatorii le
          introduc, stocheaza sau le fac accesibile prin intermediul
          Software-ului, pentru a beneficia de funcționalitățile acesteia,
          respectiv pentru monitorizarea de catre institutiile publice inrolate
          in platforma Sirar a implementarii masurilor dispuse sau recomandate
          de catre organele de audit si/sau control competente, in urma
          inspectiilor efectuate la asemenea institutii publice.
        </p>
        <p>
          Societatea, prin reprezentantii sai autorizati, poate avea acces la
          Datele personale prelucrate, cu ocazia efectuarii activitatilor sale
          de intretinere si mentenanta asupra Software-ului sau la solicitarea
          expresa a sau cu autorizarea Utilizatorului interesat. De asemenea,
          Societatea mai poate oferi acces la Datele generate de Utilizator
          autoritatilor competente, in conditiile legii.
        </p>
        <p>
          <b>
            <i>
              Scopul (scopurile) în care sunt prelucrate datele cu caracter
              personal în numele operatorului
            </i>
          </b>
        </p>
        <p>
          Folosirea Software-ului de către Utilizatori in vederea monitorizarii
          de catre institutiie publice inrolate in platforma Sirar a
          implementarii masurilor dispuse sau recomandate de catre organele de
          audit si/sau control competente, in urma inspectiilor efectuate la
          asemenea institutii publice.
        </p>
        <p>
          <b>
            <i>Durata prelucrării</i>
          </b>
        </p>
        <p>
          Datele vor fi prelucrate de SIRAR pe durata când Utilizatorii au un
          cont activ în cadrul platformei Sirar sau până la momentul la care
          Utilizatorii aleg sa le stearga.{' '}
        </p>
        <Space vertical={variables.verticalSpace} />
        <h4>
          <p>
            <b>ANEXA III</b>
          </p>
        </h4>
        <p>
          Descrierea măsurilor de securitate tehnice și organizatorice
          implementate de persoana (persoanele) împuternicită (împuternicite) de
          operator (inclusiv orice certificări relevante) pentru a asigura un
          nivel de securitate adecvat, ținând seama de natura, domeniul de
          aplicare, contextul și scopul prelucrării, precum și riscurile pentru
          drepturile și libertățile persoanelor fizice.{' '}
        </p>
        <ul>
          <li>
            <p>
              Sirar Solutions SRL este certificat ISO 27001, ceea ce confera un
              inalt grad de incredere in masurile de siguranta informatica
              aplicate la nivelul de organizatie, in special in cee ace priveste
              confidentialitatea, integritatea si disponibilitatea informatiei
            </p>
          </li>
        </ul>
        <Space vertical={variables.verticalSpace} />
        <h4>
          <p>
            <b>ANEXA IV</b>
          </p>
        </h4>
        <p>
          <b>Lista subcontractanților (subimputernicitilor)</b>
        </p>
        <Space vertical={variables.verticalSpace} />
        <h4>
          <p>
            <b>PARTEA II – Clauze Suplimentare</b>
          </p>
        </h4>
        <ol type='1'>
          <li>
            <p>
              <b>INTERPRETAREA ACORDULUI</b>
            </p>
          </li>
          <ul className={styles.ulNone}>
            <li>
              <p>
                1.1. Prezentul Acord se completează cu dispozițiile Contractului
                de furnizare a Software-ului, si cu documentele contractuale
                menționate in Termenii si Conditiile de utilizare a
                Software-ului (link).{' '}
              </p>
            </li>
            <li>
              <p>
                1.2. Orice prevederi existente cu privire la prelucrarea datelor
                cu caracter personal de către Părți vor fi înlocuite cu
                prevederile prezentului Acord, de la data intrării sale în
                vigoare.
              </p>
            </li>
            <li>
              <p>
                1.3. Dacă nu au altă definiție expres menționată în cuprinsul
                acestui document sau dacă din context nu rezultă altceva,
                termenii folosiți cu majusculă au înțelesul folosit în legea
                aplicabila.
              </p>
            </li>
            <li>
              <p>
                1.4. Cu privire la următoarele articole din clauzele standard
                (Partea I) sunt făcute următoarele precizări:
              </p>
              <ol type='a'>
                <li>
                  <p>
                    Referirile la Regulamentul (UE) 2018/1725 nu sunt aplicabile
                    în ceea ce privește obiectul Acordului.
                  </p>
                </li>
                <li>
                  <p>
                    Art. 5a), in cazul Utilizatorilor, consimțământul de a adera
                    la Acord este exprimat prin crearea si folosirea contului de
                    utilizator al Software-ului.
                  </p>
                </li>
                <li>
                  <p>
                    Art. 7.1– In acest caz, instrucțiunile documentate ale
                    operatorului sunt comenzile introduse în cadrul
                    Software-ului, ce permit stocarea si accesarea datelor
                    personale relevante.
                  </p>
                </li>
                <li>
                  <p>Art. 7.5 – Nu sunt prelucrate date sensibile.</p>
                </li>
                <li>
                  <p>
                    Art. 7.6 – Auditurile operatorului vor fi efectuate in
                    principal prin analiza documentelor si informațiilor puse la
                    dispoziția operatorului de către persoana împuternicită de
                    operator. Orice inspecție la instalațiile fizice ale
                    persoanei împuternicite de operator va trebui temeinic
                    justificată și nu va putea aduce atingere confidențialității
                    informațiilor cu caracter sensibil aparținând persoanei
                    împuternicite de operator, și nici nu va putea perturba, în
                    mod abuziv, activitatea persoanei împuternicite de operator.
                  </p>
                </li>
                <li>
                  <p>
                    Art. 7.8 – Partile nu au in vedere transferuri
                    internationale de date personale la data prezentului Acord.
                  </p>
                </li>
              </ol>
            </li>
          </ul>
          <li>
            <b>
              <p>NOTIFICĂRI</p>
            </b>
            <ul className={styles.ulNone}>
              <li>
                <p>
                  2.1. Orice comunicări între Părți (inclusiv notificări,
                  plângeri, solicitări sau răspunsuri) vor fi transmise în scris
                  prin poștă cu scrisoare cu confirmare de primire, prin fax sau
                  prin email, cu confirmare de primire, folosindu-se datele de
                  contact menționate în antetul Acordului sau, dupa caz,
                  furnizate de catre Utilizator in cadrul Software-ului.
                </p>
              </li>
              <li>
                <p>
                  2.2. Notificările transmise prin poștă se consideră primite la
                  data menționată pe confirmarea de primire.
                </p>
              </li>
              <li>
                <p>
                  2.3. Notificările transmise prin fax sau email se consideră
                  primite în ziua următoare transmiterii acestora.
                </p>
              </li>
              <li>
                <p>
                  2.4. Orice schimbare a datelor de contact va fi notificată
                  celeilalte Părți în scris, sub sancțiunea neluării în
                  considerare.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <b>ÎNCHEIEREA, MODIFICAREA ȘI ÎNCETAREA ACORDULUI </b>
            </p>
            <ul className={styles.ulNone}>
              <li>
                <p>
                  3.1. Prin crearea contului Dvs. si utilizarea Software-ului
                  deveniți parte a acestui Acord, în calitate de operator de
                  date cu caracter personal, având drepturile și prevăzute de
                  acesta, precum și de legislația aplicabilă.{' '}
                </p>
              </li>
              <li>
                <p>
                  3.2. Din timp în timp, în funcție de modificările legislative
                  sau de modificarea practicilor noastre, putem decide să
                  modificăm prezentul Acord, cu respectarea cerințelor minimale
                  impuse de lege. Orice asemenea notificare va fi notificată
                  către dvs. prin e-mail, cu 5 zile înainte de intrarea în
                  vigoare. In situația în care nu sunteți de acord cu
                  modificarea Acordului, aveți posibilitatea de a denunța acest
                  Acord în termen de 5 zile de la primirea notificării de
                  modificare din partea noastră.{' '}
                </p>
              </li>
              <li>
                <p>
                  3.3. Acordul încetează la data încetării raporturilor
                  contractuale dintre noi si Dvs., conform Termenilor si
                  Condițiilor de utilizare a Software-ului (link){' '}
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <b>RĂSPUNDERE</b>
            </p>
            <ul className={styles.ulNone}>
              <li>
                <p>
                  4.1. Fiecare Parte poartă întreaga răspundere pentru modul în
                  care obține și transmite către cealaltă Parte Datele personale
                  prevăzute în prezentul Acord.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <b>DIVERSE</b>
            </p>
            <ul className={styles.ulNone}>
              <li>
                <p>
                  5.1. Acordul intră în vigoare de la data creării contului Dvs.
                  de utilizator al Software-ului SIRAR, în forma de la momentul
                  respectiv.
                </p>
              </li>
              <li>
                <p>
                  5.2. Acordul poate fi modificat, din timp în timp, din motive
                  operaționale sau ca urmare a unor schimbări legislative. SIRAR
                  va face eforturi rezonabile pentru a notifica Utilizatorii cu
                  privire la orice asemenea modificare prin e-mail transmis la
                  adresele relevante de contact.{' '}
                </p>
              </li>
              <li>
                <p>
                  5.3. Acordul este guvernat de legea română. Orice litigiu
                  între Părți cu privire la Acord se soluționează de instanțele
                  competente de la sediul SIRAR SOLUTIONS SRL.
                </p>
              </li>
              <li>
                <p>
                  5.4. In cazul unui transfer al drepturilor privind Software-ul
                  SIRAR, cesionarul/succesorul SIRAR SOLUTIONS SRL se va subroga
                  in drepturile SIRAR SOLUTIONS SRL, fara niciun fel de alta
                  formalitate. Pentru scopuri de opozabilitate, transferul va fi
                  notificat catre Utilizatori de catre SIRAR SOLUTIONS SRL,
                  potrivit prezentului.{' '}
                </p>
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </section>
  );
};

export default DataProcessingAgreement;
